import { render, staticRenderFns } from "./CommonStoreList.vue?vue&type=template&id=0b629956&scoped=true"
import script from "./CommonStoreList.vue?vue&type=script&lang=js"
export * from "./CommonStoreList.vue?vue&type=script&lang=js"
import style0 from "./CommonStoreList.vue?vue&type=style&index=0&id=0b629956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b629956",
  null
  
)

export default component.exports